<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showQrcode">查看二维码</el-button>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/firefightingClockIn/add')">新增</el-button>
      </template>

      <!-- <el-card shadow="never" class="mt10"> -->
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="现场图片" prop="sitePhoto">
          <template v-slot="{ row }">
            <el-image v-if="row.sitePhoto" style="width: 50px; height: 50px" :src="row.sitePhoto"
              :preview-src-list="[row.sitePhoto]" fit="cover" />

          </template>
        </el-table-column>
        <el-table-column min-width="160" label="创建人姓名" prop="createUserName"></el-table-column>
        <el-table-column min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <!-- <el-button type="text" @click="showQrcode(row.pointQr)">查看二维码</el-button> -->
            <el-button type="text" @click="
              $router.push('/firefightingClockIn/detail?clockId=' + row.clockId)
              ">详情</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.clockId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
      <!-- </el-card> -->
      <el-dialog title="二维码" :visible.sync="dialogVisible" width="400px">
        <el-image style="width: 100%; height: 100%" :src="qrCodeImg" fit="cover" />
      </el-dialog>
    </custom-actions>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'firefightingClockIn',
  mixins: [keepAlive],

  data() {
    return {
      dialogVisible: false,
      qrCodeImg: '',
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {

      },

      rowId: ''

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },

    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  created() {
    this.loadData()
  },

  methods: {
    showQrcode() {
      this.qrCodeImg = process.env.BASE_URL + 'img/xiaofangcode.png'
      this.dialogVisible = true
    },
    deleteRow(clockId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.firefightingClockIn.deleteDataPaFireClockin, {
          clockId
        }).then(() => {
          this.loadData()
        })
      })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.firefightingClockIn.selectPaFireClockinByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }

  }
}
</script>
<style lang="scss" scoped></style>
